var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoyalLIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 14",
    enableBackground: "new 0 0 42 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M13 0h29v6H13zM0 0h11v6H0zM13 8h29v6H13zM0 8h11v6H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoyalLIcon);
export default __webpack_public_path__ + "static/media/royal_l_icon.0021901adc3373f1a6383e957dbcde7a.svg";
export { ForwardRef as ReactComponent };